module.exports = __webpack_public_path__ + "media/images/riders/MATT_WALKER-2ef064a475a92f2462162d2561c82215.png";